import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';

import { baseMapDispatchToProps, baseMapStateToProps, ComponentBase } from '../componentBase';

import styles from './loggedOutPage.module.scss';
import { LoginForm } from './loginForm';

class LoggedOutPage extends ComponentBase {
  protected loggedInRender() {
    return <Redirect to="/events" />;
  }

  protected loggedOutRender() {
    return (
      <div className={styles.loggedOutPage}>
        <div className={styles.centerFormInfo}>
          <h1>Clipping Platform</h1>
          <h3>Before you can use the application you need to login.</h3>
          {/* eslint-disable-next-line react/no-unescaped-entities */}
          <p>If you don't know your login details, please contact the system administrator.</p>
        </div>
        <LoginForm />
      </div>
    );
  }
}

export default connect(baseMapStateToProps, baseMapDispatchToProps)(LoggedOutPage);
